<template>
  <a
    v-tooltip="content"
    class="tooltip"
    :class="{ ['tooltip--text-link']: isTextLink }"
  >
    <slot>
      <dotcom-icon
        class="tooltip__icon"
        name="circle-info"
        art="light"
        color="--c-primary-color-3"
        hover-color="--c-tint-color-1"
      />
    </slot>
  </a>
</template>

<script>
import Vue from 'vue'

import tooltipDirective from '@/directives/tooltip'

Vue.directive('tooltip', tooltipDirective)

export default {
  name: 'DotcomTooltip',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    content: {
      type: String,
      default: '',
    },
    isTextLink: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="postcss" scoped>
.tooltip {
  font-weight: inherit;
  color: inherit;

  &:not(&--text-link):hover {
    border-bottom: none;
  }

  &--text-link {
    border-bottom: 1px dotted var(--c-primary-color-2);
  }
}
</style>

<style lang="postcss">
/** overwrite some tippy styles **/
.tippy-box p {
  color: var(--c-primary-neutral-3);
  margin: var(--spacing-2) 0;
}
</style>
